import React from 'react'
import { useTranslation } from 'react-i18next'

const SIZES = {
  sm: { btn: 'px-4 py-1.5 text-sm', icon: 'w-4 h-4' },
  md: { btn: 'px-6 py-2 text-base', icon: 'w-6 h-6' },
  lg: { btn: 'px-8 py-3.5 text-lg', icon: 'w-7 h-7' },
}

const PurchaseButton = ({ link, size = 'md' }) => {
  const { t } = useTranslation('model')
  const s = SIZES[size] || SIZES.md
  return (
    <a href={link} target="_blank" rel="noopener noreferrer">
      <div className='flex justify-center'>
        <button
          className={`flex justify-center items-center border-black rounded-md ${s.btn} mt-2 text-white font-semibold bg-blue-600 hover:bg-blue-500 hover:scale-105 hover:shadow-md transition-transform ease-in-out duration-150 whitespace-nowrap`}>
          <img src='/trolley.png' alt={t('oferta.koszyk_alt')} className={`${s.icon} inline-block mr-2`} />
          {t('oferta.do_sklepu')}
        </button>
      </div>
    </a>
  )
}

export default PurchaseButton